import type { ExtendedConstraints, CapabilityConfig } from '../../types';
import { hasOnlyKeysFromSet } from '../../utils';

export const id = 'backend';

export enum Events {}
export enum Actions {}

export type Constraints = ExtendedConstraints<{
  events: Events;
  actions: Actions;
  config: Config;
}>;

export type Config = CapabilityConfig & {
  type: typeof id;
  url: string;
  filter: string[];
  isAuthRequired?: boolean;
};

const VALID_CONFIG_KEYS = ['type', 'url', 'filter', 'isAuthRequired'] as const;

export function isValidConfig(config: CapabilityConfig): config is Config {
  if (!hasOnlyKeysFromSet(config, VALID_CONFIG_KEYS)) {
    return false;
  }

  if (
    typeof config.type !== 'string' ||
    typeof config['url'] !== 'string' ||
    !Array.isArray(config['filter']) ||
    (config['isAuthRequired'] !== undefined &&
      typeof config['isAuthRequired'] !== 'boolean')
  ) {
    return false;
  }

  if (config.type !== id) {
    return false;
  }

  return true;
}
